import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { AUDIENCES } from "@/data/content";

export default function Audiences() {
  return (
    <section id="unternehmen" className="relative py-16 sm:py-24 lg:py-32" data-testid="audiences-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-3">
              <span className="h-px w-8 bg-[#e01e37]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#e01e37]">
                Für Unternehmen
              </span>
            </div>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.02]">
              Gebaut für skalierende Organisationen.
            </h2>
          </div>
          <p className="max-w-md text-base text-white/55 leading-relaxed">
            Von Plattformen bis zu regulierten Netzwerken – CashFUX passt sich
            Ihrem Geschäftsmodell an, nicht umgekehrt.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-[#05060a] p-8 lg:p-12 transition-colors duration-500 hover:bg-[#0a0c12]"
              data-testid={`audience-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="flex h-14 w-14 items-center justify-center border border-white/10 text-white/80 transition-colors duration-300 group-hover:border-[#e01e37]/50 group-hover:text-[#e01e37]">
                  <a.icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <ArrowUpRight className="h-5 w-5 text-white/20 transition-all duration-300 group-hover:text-[#e01e37] group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <h3 className="mt-8 font-display text-2xl lg:text-3xl font-bold tracking-tight text-white">
                {a.title}
              </h3>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/55">
                {a.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
